import { SET_USER_DETAILS,SET_ROUTE_ACCESS } from '../actions/types'

const initialState = {
  userDetails: {},
  routeAccess: {
    status: 'idle',
    paths: null,
    fullAccess: false,
    settings: { enabled: true, allowParamRoutes: true, blockWhenUnavailable: false },
    loadedAt: null,
  },
}

export default function userReducer(state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case SET_USER_DETAILS:
      return {
        ...state,
        userDetails: payload,
      }
    case SET_ROUTE_ACCESS:
      return {
        ...state,
        routeAccess: {
          ...(state.routeAccess || initialState.routeAccess),
          ...payload,
        },
      }  
    default:
      return state
  }
}